import React from 'react';
import { Trophy, BookOpen, Dumbbell, Activity, Target, ShieldCheck, ArrowUpRight, Repeat, Zap, Layers } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const skills = [{
  name: 'Muscle Up',
  icon: ArrowUpRight
}, {
  name: 'Front Lever',
  icon: Layers
}, {
  name: 'Back Lever',
  icon: Repeat
}, {
  name: 'Plancha',
  icon: Target
}, {
  name: 'HSPU',
  icon: Activity
}, {
  name: 'One Arm Pull Up',
  icon: Zap
}, {
  name: 'Fuerza Empuje',
  icon: Dumbbell
}, {
  name: 'Fuerza Tirón',
  icon: Dumbbell
}, {
  name: 'Tensión Isométrica',
  icon: ShieldCheck
}, {
  name: 'Resistencia',
  icon: Activity
}];
const topics = ['Técnica', 'Progresión', 'Planificación', 'Estáticos', 'Dinámicos', 'Fuerza Estricta', 'Movilidad', 'Prevención', 'Sobrecarga', 'Biomecánica', 'Tensión', 'Metodología'];
export function SolutionIntro() {
  return <section className="py-10 md:py-20 bg-brand-card border-y border-brand-border relative overflow-hidden" data-id="element-309">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-orange/5 to-transparent pointer-events-none" data-id="element-310" />

      <div className="container mx-auto px-4" data-id="element-311">
        <FadeIn className="text-center max-w-3xl mx-auto mb-8 md:mb-10" data-id="element-312">
          {/* N°1 badge — compact */}
          <div className="inline-flex items-center gap-1.5 bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-3 py-1 rounded-full font-bold tracking-widest text-[10px] md:text-xs mb-5" data-id="element-313">
            <Trophy className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-314" /> SISTEMA N°1 EN
            ARGENTINA
          </div>

          {/* Brand logo replacing CALISTENIAFIT MEGAPACK */}
          <div className="flex justify-center mb-4 md:mb-5" data-id="element-315">
            <img src="https://cdn.magicpatterns.com/uploads/jmVEZhjN4kjeswrkggkAQr/heylloyd-image-1779467902590-Photoroom.png" alt="Mundo Digital" className="h-64 md:h-96 w-auto object-contain mt-[-100px] mb-[-100px]" style={{
            filter: 'invert(1) brightness(1.1)'
          }} data-id="element-316" />
          </div>

          <p className="text-sm md:text-lg text-brand-muted font-light mb-5 md:mb-6" data-id="element-317">
            Sistema completo · 6 Módulos + 6 Bonos · Nivel Intermedio y Avanzado
            ·{' '}
            <span className="text-brand-orange font-medium" data-id="element-318">
              Todo resuelto.
            </span>
          </p>

          {/* Stats — inline compact */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-5 md:mb-6" data-id="element-319">
            <div className="bg-brand-dark border border-brand-border px-3 py-1.5 md:px-4 md:py-2 rounded-lg flex items-center gap-2" data-id="element-320">
              <BookOpen className="w-4 h-4 md:w-5 md:h-5 text-brand-orange" data-id="element-321" />
              <span className="font-display text-base md:text-xl" data-id="element-322">
                +360 pág.
              </span>
            </div>
            <div className="bg-brand-dark border border-brand-border px-3 py-1.5 md:px-4 md:py-2 rounded-lg flex items-center gap-2" data-id="element-323">
              <Dumbbell className="w-4 h-4 md:w-5 md:h-5 text-brand-orange" data-id="element-324" />
              <span className="font-display text-base md:text-xl" data-id="element-325">
                60+ rutinas
              </span>
            </div>
          </div>

          {/* Topics — single wrap row */}
          <div className="flex flex-wrap justify-center gap-1.5 mb-5" data-id="element-326">
            {topics.map((topic, i) => <span key={i} className="text-[10px] md:text-xs text-brand-muted bg-brand-dark px-2 py-0.5 md:py-1 rounded border border-brand-border/50" data-id="element-327">
                {topic}
              </span>)}
          </div>

          <p className="text-xs md:text-sm text-brand-text font-medium" data-id="element-328">
            Funciona desde hoy en tu casa, patio o parque más cercano.
          </p>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-329">
          <h3 className="text-xl md:text-2xl text-center mb-5 md:mb-6" data-id="element-330">
            Habilidades incluidas:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 md:gap-3" data-id="element-331">
            {skills.map((skill, i) => {
            const Icon = skill.icon;
            return <div key={i} className="bg-brand-dark border border-brand-border p-2.5 md:p-3 rounded-lg flex items-center gap-2 hover:border-brand-orange/50 transition-colors group" data-id="element-332">
                  <div className="bg-brand-card p-1.5 rounded-md group-hover:bg-brand-orange/10 transition-colors shrink-0" data-id="element-333">
                    <Icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-334" />
                  </div>
                  <span className="text-[11px] md:text-xs font-medium text-brand-muted group-hover:text-brand-text transition-colors truncate" data-id="element-335">
                    {skill.name}
                  </span>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </section>;
}